import { makeAutoObservable } from 'mobx'

export class AutoControlStore {
  isAuto: boolean

  constructor(initialData?: { auto?: boolean }) {
    this.isAuto = initialData?.auto ?? false
    makeAutoObservable(this)
  }

  setIsAuto = (value: boolean) => {
    this.isAuto = value
  }
}
